import React, { forwardRef } from 'react';
import '../../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import 'classnames';
import '../../../../../common/GradientWrapper/index.js';
import { Icon } from '../../../../../common/Icon/index.js';
import '../../../../../common/LazyImage/index.js';
import '../../../../../common/NumberFormat/index.js';
import '../../../../../common/WithCustomScrollbar/index.js';
import { Base } from '../../Base.js';

const Wallet = forwardRef(
  ({
    className,
    style,
    kind,
    size,
    setOpenTooltip,
    textTooltip,
    // isOpenTooltip = false,
    ...props
  }, forwardedRef) => /* @__PURE__ */ React.createElement(
    Base,
    {
      ...props,
      ref: forwardedRef,
      className,
      style,
      kind,
      buttonType: "wallet",
      size,
      icon: /* @__PURE__ */ React.createElement(Icon, { iconName: "PlusIcon" }),
      iconActive: kind === "green" ? /* @__PURE__ */ React.createElement(Icon, { iconName: "PlusV2" }) : null
    }
  )
);
Wallet.displayName = "BabyButton.Wallet";

export { Wallet };
//# sourceMappingURL=index.js.map
